/* HENA.AX — 2x1: al agregar 1 unidad del producto en promo, se agrega 1 más (el segundo lo descuenta Shopify) */
(function () {
  'use strict';
  var cfg = window.hx2x1 && window.hx2x1.stock; if (!cfg) return;
  var original = window.fetch; if (!original) return;

  // cantidad final: el doble, sin pasar del stock disponible
  function doble(q, stock) {
    q = parseInt(q, 10); if (!q || q < 1) q = 1;
    var d = q * 2;
    if (typeof stock === 'number' && stock < 9999 && d > stock) d = stock;
    return d < q ? q : d;
  }
  function esAgregar(url) { return /\/cart\/add(\.js)?(\?|$)/.test(url || ''); }

  window.fetch = function (input, init) {
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (esAgregar(url) && init && init.body) {
        var b = init.body;
        if (typeof FormData !== 'undefined' && b instanceof FormData) {
          var id = String(b.get('id') || '');
          if (id && Object.prototype.hasOwnProperty.call(cfg, id)) b.set('quantity', String(doble(b.get('quantity') || 1, cfg[id])));
        } else if (typeof b === 'string') {
          if (b.charAt(0) === '{') {
            var o = JSON.parse(b);
            var arreglar = function (it) { if (it && cfg.hasOwnProperty(String(it.id))) it.quantity = doble(it.quantity || 1, cfg[String(it.id)]); };
            if (o.items) o.items.forEach(arreglar); else arreglar(o);
            init.body = JSON.stringify(o);
          } else {
            var p = new URLSearchParams(b), pid = p.get('id');
            if (pid && cfg.hasOwnProperty(pid)) { p.set('quantity', String(doble(p.get('quantity') || 1, cfg[pid]))); init.body = p.toString(); }
          }
        }
      }
    } catch (e) { /* ante cualquier duda, no tocamos el pedido */ }
    return original.apply(this, arguments);
  };
})();
